<template>
    <div class="commute padding">
        <h1 class="big">{{ $t('commute.title.total') }}
        
        <span v-if="total_annual_cost > 0">
            : {{ convert('formatMoney', total_annual_cost, 0) }}
        </span>
        
        </h1>
        
        <div id="totalTable" class="table">
            <div class="body">
            
                <div class="tablerow" v-if="commutes.length > 1"   >
                    <div class="cell">&nbsp; </div>
                    <div class="cell" v-for="commute in commutes">
                        <a class="item" href="#" v-scroll-to="'#commute_'+commute.number">
                        {{ $t('commute.title.number', {commute_number : commute.number}) }}
                        <hr />
                        <span v-if="commute.data.complete" class="capitalize">
                        <span v-html="convert('vehicleIcon', commute)"></span>
                        {{ vehicle_label(commute.data.vehicle) }}
                        </span>
                        <span v-else>
                            ({{ $t('commute.label.incomplete') }})
                        </span>
                        </a>
                    </div>  
                </div>
                
                <div class="tablerow">
                    <div class="cell nobr">{{ $t('commute.commutes_per_year') }}</div>
                    <div class="cell" v-for="commute in commutes">
                        <span  v-if="commute.data.complete">
                        {{ commutes_per_year(commute.data).toFixed(1) }}
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                <div class="tablerow">
                    <div class="cell nobr">{{ $t('commute.dist_per_commute') }}</div>
                    <div class="cell" v-for="commute in commutes">
                        <span  v-if="commute.data.complete && commute.data.commute_dist_time.commute_dist > 0">
                        {{ convert('formatDistance', commute.data.commute_dist_time.commute_dist, 0) }}
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                
                <div class="tablerow">
                    <div class="cell nobr">{{ $t('commute.distance_per_year') }}</div>
                    <div class="cell" v-for="commute in commutes">
                    
                    <span  v-if="commute.data.complete && km_per_year(commute.data) > 0">
                        {{ convert('formatDistance', km_per_year(commute.data), 0) }} 
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                <!--
                 <div class="tablerow">
                    <div class="cell nobr">{{ $t('commute.duration_per_year') }}</div>
                    <div class="cell" v-for="commute in commutes" v-if="commute.data.complete">
                        {{ parseFloat(duration_per_year(commute.data) / 24).toFixed(1) }} 
                    </div>  
                </div>
                -->
                
                <div class="tablerow">
            
                    <div class="cell nobr">{{ $t('commute.average_speed') }} </div>
                    <div class="cell" v-for="commute in commutes"  >
                    
                     <span  v-if="commute.data.complete && avg_commute_speed(commute.data) > 0">
                             <VehicleSpeed
                            :dist="commute.data.commute_dist_time['commute_dist']"
                            :duration="commute.data.commute_dist_time['commute_duration']*60"
                            :duration_in_traffic="commute.data.commute_dist_time['commute_duration_in_traffic']*60"
                            :vehicle="commute.data.vehicle"
                            />
            
                            <img v-if="commute.data.vehicle.movement_type === 'driving'"
                            v-tooltip="$t('commute.duration.depending-on-traffic') + ' 😉'" height="14" src="icons/huh_18.png">


                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                <div class="tablerow" v-if="total_annual_fuel_volume > 0" >
                    <div class="cell nobr">{{ $t('commute.fuel_volume_per_year') }} </div>
                    <div class="cell" v-for="commute in commutes">
                    
                        <span  v-if="fuel_volume_per_year(commute.data) > 0">
                        {{ convert('formatVolume', fuel_volume_per_year(commute.data), 0) }}
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
        
                <div class="tablerow" v-if="total_annual_fuel_volume > 0">
                    <div class="cell nobr">{{ $t('commute.fuel_cost_per_year') }} </div>
                    <div class="cell" v-for="commute in commutes">
                     <span  v-if="vehicle_fuel_cost_per_year(commute.data) > 0">
                        {{ convert('formatMoney', vehicle_fuel_cost_per_year(commute.data), 0) }}
                        </span>
                        <span v-else-if="isNaN(vehicle_fuel_cost_per_year(commute.data))" >
                        
                        <a href="#" v-scroll-to="'#energy_cost_fuel'">
                        <img src="icons/warning_18.png" v-tooltip="$t('warning.missing-fuel-cost')" />
                         </a>
                        </span>
                        
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
        
                <div class="tablerow" v-if="total_annual_electricity > 0">
                    <div class="cell nobr">{{ $t('commute.electricity_per_year') }} </div>
                    <div class="cell" v-for="commute in commutes"  >
                    
                     <span v-if="electricity_per_year(commute.data) > 0">
                        {{ electricity_per_year(commute.data).toFixed(0) }} kWh
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                                   
                <div class="tablerow" v-if="total_annual_electricity > 0">
                    <div class="cell nobr">{{ $t('commute.electricity_cost_per_year') }} </div>
                    <div class="cell" v-for="commute in commutes" >
                    
                     <span  v-if="vehicle_electricity_cost_per_year(commute.data) > 0">
                        {{ convert('formatMoney', vehicle_electricity_cost_per_year(commute.data),0) }}
                        </span>
                        <span v-else-if="isNaN(vehicle_electricity_cost_per_year(commute.data))" >
                        <a href="#" v-scroll-to="'#energy_cost_electricity'">
                        <img src="icons/warning_18.png" v-tooltip="$t('warning.missing-electricity-cost')" />
                         </a>
                        </span>
                        
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                
                <div class="tablerow">
                    <div class="cell nobr">
                    {{ $t('commute.vehicle_cost_per_year') }} <br/>
                    <small>{{ $t('commute.vehicle_monthly_cost_per_year') }}</small> <br/>
                    <small>{{ $t('commute.vehicle_maintenance_cost_per_year') }}</small> <br/>
                    
                    </div>
                    <div class="cell" v-for="commute in commutes" >
                    
                     <span  v-if="commute.data.complete">
                        {{ convert('formatMoney', vehicle_cost_per_year(commute.data) + vehicle_maintenance_cost_per_year(commute.data), 0) }}<br/>
                        <small>{{ convert('formatMoney', vehicle_cost_per_year(commute.data), 0) }}</small> <br/>
                        <small>{{ convert('formatMoney', vehicle_maintenance_cost_per_year(commute.data), 0) }}</small> <br/>
                    
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                <div class="tablerow">
                    <div class="cell nobr"> <strong>{{ $t('commute.commute_annual_cost') }} </strong></div>
                    <div class="cell" v-for="commute in commutes" >
                    
                     <span  v-if="commute.data.complete && commute_annual_cost(commute.data) > 0">
                     <strong>
                        {{ convert('formatMoney', commute_annual_cost(commute.data), 0) }}
                        </strong>
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                <div class="tablerow">
                    <div class="cell nobr"><strong>{{ $t('commute.cost_per_dist_unit', {unit_distance: settings('getDistanceUnit')} ) }} </strong></div>
                    <div class="cell" v-for="commute in commutes" >
                    
                     <span  v-if="commute.data.complete && km_per_year(commute.data) > 0 && vehicle_cost_per_dist_unit(commute.data) > 0">
                     <strong>
                        {{ convert('formatMoney', vehicle_cost_per_dist_unit(commute.data), 3) }}
                        </strong>
                        </span>
                        <span v-else>
                        --
                        </span>
                    </div>  
                </div>
                
                
            </div>
        </div>
        
        <p>
        
        <img src="icons/huh_30.png" style="margin: 0 .5em .5em 0" class="float_left" v-responsive.lg.xl.md  />
        <img src="icons/huh_18.png" style="margin: 0 .5em .5em 0" class="float_left" v-responsive.sm.xs  />
        {{ $t('totals.note') }}
        </p>
        
        <Social />

        <span class="hide">
        {{ total_annual_energy_cost }}
        {{ total_annual_cost }}
        </span>
        
    </div>    
</template>

<script>

import VehicleSpeed from './VehicleSpeed.vue'
import Totals from '../mixins/Totals.js'
import Social from './Social.vue'

export default {
    mixins: [Totals],

    created() {
        for (var k in this.init_data){
            this.$data[k] = this.init_data[k];
        }
    },
    
    components: {
        VehicleSpeed, Social
    },
    data: function(){
        return {
        
        }
    },
    props: {
        commutes : Array,
        energy_costs: Object,
    }
}
    

</script>

<style>
div.commute_freq_type {
    width: 400px;
}

div.commute_freq_type > div {
    padding: .2em;
    border-radius: .2em;
}

#totalTable{
    width: 90%;
}

</style>